import actions from './actions';
import mutations from './mutations';
import status from './status';

const INITIAL_STATE = {
  list: {
    page: 1,
    records: [],
    total: 0,
  },
  details: {
    record: {},
    total: 0,
  },
};

const getters = {
  list: state => state.list,
  details: state => state.details,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
  modules: {
    status,
  },
};

export default Module;
